
  <div class="delete-modal">
    <mat-dialog-content class="mat-typography text-center">
      <!-- <h2 mat-dialog-title class="text-center">Are you sure you?</h2> -->

      <h2 class="mb-1">
        Are you sure you want to delete this item?
      </h2>
      <!-- <h4 class="font-weight-bold">
        {{ local_data.name ? local_data.name : local_data.email }}
        ?</h4> -->
    </mat-dialog-content>
    <mat-dialog-actions align="center">

      <button mat-raised-button class="btn_primary" [mat-dialog-close]="true">
        Delete
      </button>
      <button mat-raised-button class="btn text-danger cancel" mat-dialog-close (click)="onCancel()">
       Cancel
      </button>
    </mat-dialog-actions>
  </div>
